// extracted by mini-css-extract-plugin
export default {"events":"Events_events__TynAC","events_list":"Events_events_list__x0w8j"};